// extracted by mini-css-extract-plugin
export default {"cardsContainer":"Card_cardsContainer__Xe4r6","img":"Card_img__itDuD","cardIndividual":"Card_cardIndividual__y4UnZ"};